import React, { useState } from 'react'
import { Outlet, useNavigate } from 'react-router-dom'
import { useAuth } from 'context/AuthContext'
import { canManageStaff } from 'shared/util/permissions'
import Modal from 'shared/components/ui/Modal'
import Button from 'shared/components/ui/button'
import logo from '../assets/full-logo.svg'

function RootLayout() {
  const { user, logout } = useAuth()
  const navigate = useNavigate()
  const [menuOpen, setMenuOpen] = useState(false)
  const [logoutOpen, setLogoutOpen] = useState(false)
  const display = user?.sName || user?.sEmail || user?.sMobile || 'Staff'

  const confirmLogout = async () => {
    await logout()
    setLogoutOpen(false)
    navigate('/login')
  }

  return (
    <div className="flex min-h-dvh flex-col bg-bg text-ink">
      <header className="sticky top-0 z-30 flex h-14 items-center justify-between gap-3 border-b border-line bg-surface/95 px-3 backdrop-blur sm:h-16 sm:px-4 md:px-6">
        <img src={logo} alt="Gate Scanner" className="h-7 max-w-[84px] object-contain sm:h-8 sm:max-w-[96px]" />
        <button
          type="button"
          onClick={() => setMenuOpen(true)}
          className="h-10 max-w-[46vw] truncate rounded-xl bg-elevated px-2.5 text-xs font-semibold sm:h-12 sm:max-w-none sm:rounded-2xl sm:px-3 sm:text-sm"
        >
          {display}
        </button>
      </header>
      <main className="flex min-h-0 flex-1 flex-col">
        <Outlet />
      </main>
      <Modal open={menuOpen} onClose={() => setMenuOpen(false)} title={display}>
        {canManageStaff(user) && (
          <button
            type="button"
            className="mb-2 flex min-h-12 w-full items-center rounded-2xl bg-elevated px-4 text-left font-medium"
            onClick={() => {
              setMenuOpen(false)
              navigate('/staff')
            }}
          >
            Manage scanner staff
          </button>
        )}
        <button
          type="button"
          className="flex min-h-12 w-full items-center rounded-2xl bg-theme-900 px-4 text-left font-medium text-theme"
          onClick={() => {
            setMenuOpen(false)
            setLogoutOpen(true)
          }}
        >
          Logout
        </button>
      </Modal>
      <Modal open={logoutOpen} onClose={() => setLogoutOpen(false)} title="Confirm logout?">
        <p className="mb-5 text-muted">You will need to verify OTP to sign back in.</p>
        <div className="grid grid-cols-2 gap-2">
          <Button variant="ghost" onClick={() => setLogoutOpen(false)}>
            Cancel
          </Button>
          <Button onClick={confirmLogout}>Logout</Button>
        </div>
      </Modal>
    </div>
  )
}

export default RootLayout
